import {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import push from "push.js";
import {getMessaging} from "../services/firebaseclient/index";
import {PLAIN_HEADER_API} from "../services/HttpHandler/index";
import {getFirebaseToken} from "../services/commons/index";
import {setItemToLocalStorage} from "../util/LocalStorage/index";
import {setBookedTokenDetails} from "../actions/booking";

const useMessaging = () => {
  const nullData = [
    {
      attendantUserId: null,
      attentionEndTime: null,
      attentionModuleCode: null,
      attentionStartTime: null,
      bookingTime: null,
      comments: null,
      customerEmail: null,
      customerName: null,
      customerPhoneNumber: null,
      moduleId: null,
      queueConfigId: null,
      serviceType: null,
      serviceTypeId: null,
      source: null,
      status: null,
      storeId: null,
      tokenNumber: null,
      userId: null,
      userIdType: null,
      uuid: null,
    },
  ];
  const [initilized, setInitilized] = useState(false);
  const [bookedTokenId, setBookedTokenId] = useState(null);
  const {firebaseToken, storeId, tokenId} = useSelector((state) => {
    return {
      firebaseToken: state.account.firebaseToken,
      storeId: state.store.storeId,
      tokenId: state.bookingDetails.tokenId,
    };
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!initilized && firebaseToken && storeId && tokenId) {
      initializeMessaging();
    } else {
      getFirebaseToken();
    }
  }, [firebaseToken, storeId, tokenId]);

  const initializeMessaging = async () => {
    setInitilized(true);
    try {
      if (Notification?.requestPermission) {
        const value = await Notification.requestPermission();
        if (value === "granted") {
          makeRegistration();
        } else if (value === "default") {
          navigator.permissions
            .query({name: "notifications"})
            .then(function (notificationPerm) {
              notificationPerm.onchange = function () {
                if (notificationPerm.state === "granted") {
                  makeRegistration();
                }
              };
            });
        }
      }
    } catch (err) {}
  };

  const makeRegistration = () => {
    getMessaging(firebaseToken)
      .then(({messaging, firebase, token}) => {
        if (tokenId) setItemToLocalStorage("tokenId", tokenId);
        PLAIN_HEADER_API.post(
          `/api/v1/turnero/token/fcmregistration`,
          {
            tokenId,
            fcmToken: token,
            storeId,
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.API_KEY}`,
            },
          }
        );
        messaging.onMessage((payload) => {
          // eslint-disable-next-line no-unused-expressions
          // audioRef?.current?.play();
          const title = payload?.data?.title
            ? payload?.data?.title
            : payload.notification?.title;
          const message = payload?.data?.message
            ? payload?.data?.message
            : payload.notification?.body;
          push.create(title, {
            body: message,
            requireInteraction: true,
            onClick: function () {
              window.focus();
              this.close();
            },
            silent: false,
          });
        });
        dispatch(setBookedTokenDetails(nullData[0]));
      })
      .catch((err) => {
        console.log("error: ", err);
      });
  };
  return;
};

export default useMessaging;
